import { SocketApiService } from "../api/SocketApiServices";
import Config from "../../utils/config/config";

const baseUrl = Config.gRPCURL
const fetchPaginatedArchiveMessage = async (conversationId, botId, startTime, fetchDirection = 'OLDER') => {
	try {
		const params = { conversationId, botId, fetchDirection, startTime };
		const response = await SocketApiService.GetPaginatedQueueMessages(params);
		console.log("Response: ====fetchPaginatedArchiveMessage=======>", response);
		if (response && response.status) {
			const responseData = response.data;
			console.log("Paginated Archive Messages:", responseData);
			return responseData;
		} else {
			console.error("Error in fetchPaginatedArchiveMessage: Invalid response status");
			return null;
		}
	} catch (error) {
		console.error("Error in fetchPaginatedArchiveMessage:", error);
		return null;
	}
};

export const ConversationServiceClient = {
	fetchPaginatedArchiveMessage,
};

export const parseBytesContent = (content) => {
	if (content && content.data && content.data.length > 0) {
		let utf8decoder = new TextDecoder();
		return JSON.parse(utf8decoder.decode(new Uint8Array(content.data)));
	}
	return content;
}